<template>
  <label :class="$style.label">
    <slot />
  </label>
</template>

<script>
export default {
  name: 'BaseLabel',
}
</script>

<style lang="scss" module>
  @import "../../../assets/scss/variables";
  .label {
    font-size: $font-size-small;
    margin: 0;
    padding: 0 .25rem;
  }
</style>
